import { useCallback } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { addCollection, updateCollection } from 'services/collection-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { prepareFilter, notify } from 'libs/common';
import { required, WhiteStyledField, Title, DictInput, ErrorMsg } from 'libs/form';
import { StyledButtonContainer } from './collection-form.styled';

const CollectionForm = (props) => {
  const { destroy, error, refresh, form, handleSubmit, close, type, initialValues } = props;
  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const id = initialValues?.id;
  const requiredT = useCallback(required(t), [t]);

  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    notify(t('messages.ВНИМАНИЕ!'), isAdd ? t('messages.Сохранено успешно') : t('messages.Изменения сохранены'), 'success');

    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const test = false;

    const out = prepareFilter({ ...values }, {}, { boolFields: ['is_active'] });

    if (!isAdd) {
      out.id = id;
      delete out.card_id;
    }

    // test
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    const method = isAdd ? addCollection : updateCollection;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((error) => {
        if (error?.message) {
          throw new SubmissionError({
            _error: error.message,
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Новый инкассатор') : initialValues?.name;

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <ErrorMsg error={error} />
        <DictInput dict="users.status" exclude={isAdd ? ['null'] : []} />
        <WhiteStyledField type="text" label={t('form.Номер БСК') + config.req} placeholder={t('form.Номер БСК')} name="card_id" validate={requiredT} disabled={!isAdd} />
        <WhiteStyledField type="text" label={t('form.ФИО') + config.req} placeholder={t('form.Иванов Иван Иванович')} name="name" validate={requiredT} />

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'collectionForm',
  // destroyOnUnmount: false,
})(CollectionForm);
